import { Box } from '@mentimeter/ragnar-ui/box';

export const RotateOnHoverAnimation = ({
  children,
  isHovering,
}: React.PropsWithChildren<{ isHovering: boolean }>) => {
  return (
    <Box
      width="100%"
      height="100%"
      extend={() => ({
        transform: isHovering ? 'translateY(-12px)' : 'translateY(0)',
        rotate: isHovering ? '-10deg' : '0',
        transition: 'all 0.3s ease-out',
      })}
    >
      {children}
    </Box>
  );
};
